import {
  prefetchPage,
  prefetchTranslation,
  prefetchModalWindowTranslation,
  prefetchCategoryPromotion,
} from '@Navigation/prefetchers';
import { prefetchInfiniteCategory } from '@Queries/useInfiniteCategory';

import type { LoaderFn } from '@Types/Router';

export const loader: LoaderFn = (query) => async (args) => {
  const { queryClient } = query;
  const { request, params } = args;
  const { page = '' } = params;
  const { search } = new URL(request.url);
  const pageNumber = parseInt(page.replace(/\D/g, ''), 10) || 1;
  const slug = 'promo-mebel-dlya-hranenia-konstruktor';

  return Promise.all([
    prefetchPage(request.url, queryClient),
    prefetchCategoryPromotion({ slug }, queryClient),
    prefetchInfiniteCategory({ slug, pageNumber, search }, queryClient),
    prefetchTranslation(request.url, queryClient),
    prefetchModalWindowTranslation('Filters', queryClient),
  ]);
};
